<template>
  <div class="row border">
    <div class="col-md-12">
      <h1 class="title-pages">CONTA CORRENTE</h1>
    </div>
    <div class="col-md-12">checking-account</div>
  </div>
</template>

<script>
export default {
  name: "CheckingAccount",
  components: {},
};
</script>
